import React from "react";
import PropTypes from "prop-types";
import { Button, Header, Label, Message, Segment } from "semantic-ui-react";
import { formatDate } from "../formatters";

const AutomationIncidents = ({ incidents, page, onPageChange }) => (
  <Segment className="automation-monitoring__analysis-section">
    <Header as="h2">Active and recent incidents</Header>
    {(incidents?.items || []).length === 0 ? <Message content="No incidents match this workflow." /> : incidents.items.map((incident) => (
      <div className="automation-monitoring__incident" key={incident.id}>
        <Label color={incident.active ? "red" : "grey"}>{incident.active ? "Active" : "Cleared"}</Label>
        <strong>{incident.type.replace(/_/g, " ")}</strong>
        <span>{incident.stageCode || "Automation"}</span>
        <span>{formatDate(incident.lastSeenAt)}</span>
      </div>
    ))}
    <Button disabled={!incidents || page <= 1} onClick={() => onPageChange(page - 1)}>Previous</Button>
    <span className="automation-monitoring__page-label">Page {page} of {incidents?.totalPages || 1}</span>
    <Button disabled={!incidents || page >= incidents.totalPages} onClick={() => onPageChange(page + 1)}>Next</Button>
  </Segment>
);

AutomationIncidents.propTypes = {
  incidents: PropTypes.object,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

AutomationIncidents.defaultProps = { incidents: null };

export default AutomationIncidents;
